/**
 * Mixin methods that handle vuex chat room actions (close, invite, leave ...)
 */
import { mapActions } from 'vuex'
import Contact from 'Store/class/contact/contact'
import API from '@/api'

export default {
  name: 'mixin-chat-room-actions',
  methods: {
    ...mapActions({
      openMembersChannelDialog: 'chat/openMembersChannelDialog',
      openChannelActionDialog: 'chat/openChannelActionDialog',
      openRenameChannelDialog: 'chat/openRenameChannelDialog',
      setContextMenuChannel: 'chat/setContextMenuChannel',
      openDeleteDirectChatDialog: 'chat/openDeleteDirectChatDialog',
      setContextMenuRoomId: 'chat/setContextMenuRoomId',
      openMembersGroupDialog: 'chat/openMembersGroupDialog',
      openGroupActionDialog: 'chat/openGroupActionDialog',
      openRenameGroupDialog: 'chat/openRenameGroupDialog',
      setContextMenuGroup: 'chat/setContextMenuGroup',
      openContactForm: 'contacts/form/open',
      openContactDetails: 'contacts/detailsDialog/open'
    }),

    onRoomAction (contextMenu, room) {
      const ogRoom = room.ogRoom
      if (ogRoom) {
        if (room.roomType === 'd') {
          if (room.isSms) {
            this.navSmsChatContextMenu(contextMenu, ogRoom)
          } else {
            this.navDirectChatContextMenu(contextMenu, ogRoom)
          }
        } else if (room.roomType === 'c') {
          this.navChannelContextMenu(contextMenu, ogRoom)
        } else if (room.roomType === 'p') {
          this.navGroupContextMenu(contextMenu, ogRoom)
        }
      }
    },

    navChannelContextMenu (contextMenu, channel) {
      const channelAction = contextMenu.key
      const options = { channelAction: channelAction, channel: channel }
      switch (channelAction) {
        case 'manage_members':
        case 'see_members':
          this.setContextMenuChannel(channel)
          this.openMembersChannelDialog()
          break
        case 'rename':
          this.setContextMenuChannel(channel)
          this.openRenameChannelDialog()
          break
        default:
          this.setContextMenuChannel(channel)
          this.openChannelActionDialog({ options })
      }
    },

    navGroupContextMenu (contextMenu, group) {
      const groupAction = contextMenu.key
      const options = { groupAction: groupAction, group: group }
      switch (groupAction) {
        case 'manage_members':
        case 'see_members':
          this.setContextMenuGroup(group)
          this.openMembersGroupDialog()
          break
        case 'rename':
          this.setContextMenuGroup(group)
          this.openRenameGroupDialog()
          break
        default:
          this.openGroupActionDialog({ options })
      }
    },

    navDirectChatContextMenu (contextMenu, directMessage) {
      const channelAction = contextMenu.key
      switch (channelAction) {
        case 'close':
          this.openDeleteDirectChatDialog()
          this.setContextMenuRoomId(directMessage.id)
          break
      }
    },

    navSmsChatContextMenu (contextMenu, smsRoom) {
      const channelAction = contextMenu.key
      switch (channelAction) {
        case 'close':
          this.openDeleteDirectChatDialog()
          this.setContextMenuRoomId(smsRoom.id)
          break
        case 'add_shared_contact':
          this.openContactCreateForm(smsRoom, false)
          break
        case 'add_personal_contact':
          this.openContactCreateForm(smsRoom, true)
          break
        case 'see_contact':
          API.getContactById(smsRoom.contactId).then(response => {
            const contact = new Contact(response.data)
            this.openContactDetails(contact)
          })
          break
      }
    },

    openContactCreateForm (smsRoom, isPersonal) {
      const isUpdate = false
      const contact = new Contact({})
      contact.isPersonal = isPersonal
      contact.phoneNumbers[0].phone_number = smsRoom.formatChatUsername()
      this.openContactForm({ contact, isUpdate })
    },

    openFile ({ file }) {
      window.open(file.file.url, '_blank')
    }
  }
}
